import { useState, useEffect } from 'react'
import {
    Box,
    Grid,
    Typography,
    Pagination,
    Skeleton,
    Card
} from '@mui/material'
import { isTablet } from 'react-device-detect'
import { NewsUrl } from '../../common/url'
import axios from 'axios'
import { ROOT_PATH, App_Language_key } from '../../common/config'
import { useTranslation } from 'react-i18next'

export const SMAppNews: React.FC = () => {
    const { t } = useTranslation()

    const [pageIndex, updatePageIndex] = useState(1)

    const [pageCount, setPageCount] = useState(1)

    const [data, setData] = useState([])

    const onChange = (event, value) => {
        updatePageIndex(value)
        fetchList(value)
    }

    const skeletonData = [
        '',
        '',
        ''
    ]

    const skeletonItem = (index: number) => {
        return (
            <Grid item key={index} xs={isTablet ? 6 : 12}>
                <Box>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'100%'} height={'260px'} style={{ borderRadius: '4px' }} ></Skeleton>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'80%'} height={'22px'} style={{ marginTop: '26px', borderRadius: '4px' }}></Skeleton>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'60%'} height={'16px'} style={{ marginTop: '16px', borderRadius: '4px' }}></Skeleton>
                    <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'40%'} height={'16px'} style={{ marginTop: '16px', borderRadius: '4px' }}></Skeleton>
                </Box>
            </Grid>
        )
    }

    const language = sessionStorage.getItem(App_Language_key) === 'ms' ? 'BM' : 'EN'

    const fetchList = async (page: number) => {
        try {
            const response = await axios.get(NewsUrl + '?pagination[page]=' + page + '&pagination[pageSize]=9&sort=sequence:ASC&publicationState=live&filters[language][$eq]='+ language)
            setData(response.data['data'])
            setPageCount(response.data['meta']['pagination']['pageCount'])
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        ; (async () => {
            await fetchList(1)
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const detail = (id: number) => {
        window.location.href = (ROOT_PATH + '/news-detail?id=' + id)
    }

    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            paddingLeft: '12px',
            paddingRight: '12px',
            paddingTop: '30px',
            paddingBottom: '40px',
            display: 'flex',
            flexDirection: 'column'
        }}>

            {
                data === null || data.length === 0 ?
                    (<Box>
                        <Grid container rowSpacing={4} columnSpacing={isTablet ? 2 : 0}>
                            {skeletonData.map((item, index) => (
                                skeletonItem(index)
                            ))}
                        </Grid>
                    </Box>)
                    :
                    (<Box sx={{ width: '100%' }}>
                        <Grid
                            container
                            rowSpacing={3}
                            columnSpacing={isTablet ? 2 : 0}
                        >
                            {data.map((item, index) => (
                                <Grid item key={index} xs={isTablet ? 6 : 12}>
                                    <Box
                                        onClick={() => detail(data[index]['id'])}
                                        sx={{
                                            width: '100%',
                                            borderRadius: 6,
                                            cursor: 'pointer',
                                        }}>
                                        <Card
                                            style={{
                                                borderRadius: '4px',
                                                boxShadow: 'none',
                                                border: 'none',
                                                '&:hover': {
                                                    boxShadow: 'none'
                                                }
                                            }}
                                        >
                                            <div dangerouslySetInnerHTML={{ __html: data[index]['attributes']['image'] }} style={{ minHeight: '150px', borderRadius: '4px' }} />
                                        </Card>

                                        <Typography fontWeight={400} fontSize={'12px'} color={'#6B6B6B'} sx={{
                                            paddingTop: '20px'
                                        }}>
                                            {data[index]['attributes']['Description']}
                                        </Typography>
                                        <Typography fontWeight={700} fontSize={'20px'} color={'#141F39'} sx={{
                                            paddingTop: '6px'
                                        }}>
                                            {data[index]['attributes']['title']}
                                        </Typography>
                                        <Typography fontWeight={500} fontSize={'16px'} color={'#6B6B6B'} sx={{
                                            paddingTop: '6px'
                                        }}>
                                            {t('t76')}
                                        </Typography>
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>)
            }

            {/* page */}
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                alignContent: 'center',
                paddingTop: '30px',
            }}>
                <Pagination page={pageIndex} onChange={onChange} count={pageCount} variant="outlined" shape="rounded"></Pagination>
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMAppNews
